import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import NominaOtrosPagosForm from './NominaOtrosPagosForm';
import NominaOtrosPagosList from './NominaOtrosPagosList';

class NominaOtrosPagosManager extends Component {

  state = {}

  handleOnAdd = (data) => {
    const { OtrosPagos = {} } = this.props.data;
    const { OtroPago = [] } = OtrosPagos;

    const newList = OtroPago.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newList);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  handleOnListChange = (data) => {
    this.props.onChange({
      ...this.props.data,
      OtrosPagos: {
        OtroPago: data
      }
    });
  }

  render() {
    const { data } = this.state;
    const { OtrosPagos = {} } = this.props.data;
    const { OtroPago = [] } = OtrosPagos;

    return (
      <>
        <div className="pb-4">
          <div>
            <strong className="text-black text-upper">Otros pagos</strong>
          </div>
        </div>

        <div className="pb-4">
          <div className="section pt-2">
            <div data-testid="nomina-otrospagos-form">
              <NominaOtrosPagosForm
                data={ data }
                onAdd={ this.handleOnAdd }
                />
            </div>

            <div className="pt-2" data-testid="nomina-otrospagos-list">
              <NominaOtrosPagosList
                data={ OtroPago }
                onEdit={ this.handleOnEdit }
                onChange={ this.handleOnListChange }
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default NominaOtrosPagosManager;